import {
  getEncodedParamFromUrl,
  getCookieValue,
  objectFromCookieValue,
} from '@turbodebt/turbo-shared'
import { getSessionValue } from '../default/getSessionValue'

/**
 * @param {string} SESSION_ID
 * @returns {DecodedParams}
 */
export function getThanksParams(SESSION_ID = 'tdMainFunnel') {
  const parsedParams = /** @type {ThanksParams} */ (getEncodedParamFromUrl())
  const leadDataCookie = getCookieValue('leadData')
  if (leadDataCookie) {
    const leadDataParams = objectFromCookieValue(leadDataCookie)
    Object.assign(parsedParams, leadDataParams)
  }

  const debtOwed = parsedParams?.debtOwed || 10000
  const email = parsedParams?.email || ''
  const eventID =
    (parsedParams?.eventID || '').toString() ||
    (new Date().getTime() + Math.floor(Math.random() * 1000)).toString()
  const firstName = parsedParams?.firstName || parsedParams?.first || ''
  const lastName = parsedParams?.lastName || parsedParams?.last || ''
  const phone = (parsedParams?.phone || '').replace(/\D/g, '')
  const state =
    parsedParams?.state || getSessionValue(SESSION_ID, 'region') || ''
  const zipcode = parsedParams?.zipcode || ''

  const sub1 = getSessionValue(SESSION_ID, 'sub1') || parsedParams?.sub1 || ''
  const aff_id =
    getSessionValue(SESSION_ID, 'aff_id') || parsedParams?.affId || ''
  const utmCampaign =
    getSessionValue(SESSION_ID, 'utm_campaign') ||
    parsedParams?.utmCampaign ||
    ''
  const utmSource =
    getSessionValue(SESSION_ID, 'utm_source') || parsedParams?.utmSource || ''

  const affId = utmCampaign || aff_id
  const trksub = affId || utmSource
  const encodedSub1 = btoa(sub1)

  const clickId = eventID

  return {
    debtOwed,
    email,
    eventID,
    firstName,
    lastName,
    phone,
    state,
    zipcode,
    sub1,
    aff_id,
    utmCampaign,
    utmSource,
    affId,
    trksub,
    encodedSub1,
    clickId,
  }
}
